<template>
  <div>
    <b-card title="Information">
      <validation-observer ref="observer">
        <b-row>
          <!-- Champs pour le nom, prénom, e-mail et téléphone -->
          <b-col md="6" class="mb-1">
            <b-form-group label="Civilité" label-for="civiliteInput">
<!--              <validation-provider #default="{ errors }" name="Civilité" rules="required">:state="errors.length > 0 ? false : null"-->
                <b-form-input v-model="user.civilite" placeholder="Civilité" @input="emitUserInfoUpdate" />
                  
<!--              </validation-provider>-->

            </b-form-group>
          </b-col>
          <b-col md="6" class="mb-1">
            <b-form-group label="Matricule" label-for="matriculeInput">
<!--              <validation-provider #default="{ errors }" name="Matricule" rules="required">:state="errors.length > 0 ? false : null"-->
                <b-form-input v-model="user.matricule" placeholder="Matricule" @input="emitUserInfoUpdate" />
<!--              </validation-provider>-->

            </b-form-group>
          </b-col>
          <b-col md="6" class="mb-1">
            <b-form-group label="Nom" label-for="nomInput">
              <validation-provider #default="{ errors }" name="Nom" rules="required">
                <b-form-input v-model="user.lastName" :state="errors.length > 0 ? false : null"
                  @input="emitUserInfoUpdate" placeholder="Nom" />
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Champs pour le prénom -->
          <b-col md="6" class="mb-1">
            <b-form-group label="Prénom" label-for="prenomInput">
              <validation-provider #default="{ errors }" name="Prénom" rules="required">
                <b-form-input v-model="user.firstName" :state="errors.length > 0 ? false : null"
                  @input="emitUserInfoUpdate" placeholder="Prénom" />
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Champs pour l'e-mail required|-->
          <b-col md="6" class="mb-1">
            <b-form-group label="E-mail" label-for="mailInput">
<!--              <validation-provider #default="{ errors }" name="E-mail" rules="email"> :state="errors.length > 0 ? false : null-->
                <b-form-input v-model="user.mail" @input="emitUserInfoUpdate"
                  placeholder="E-mail" />
<!--              </validation-provider>-->
            </b-form-group>
          </b-col>
          <!-- Champs pour le téléphone -->
          <b-col md="6" class="mb-1">
            <b-form-group label="Téléphone" label-for="telephoneInput">
              <validation-provider #default="{ errors }" name="Téléphone" rules="required">
                <b-form-input v-model="user.telephone" :state="errors.length > 0 ? false : null"
                  @input="emitUserInfoUpdate" placeholder="Téléphone" />
              </validation-provider>
            </b-form-group>
          </b-col>
        
          <b-col md="6" class="mb-1">
            <b-form-group label="Date d'embauche" label-for="fonctionDateInput">
              <validation-provider #default="{ errors }" name="Date d'embauche" rules="required">
                <b-form-datepicker v-model="selectedDate" :state="errors.length > 0 ? false : null" :max="maxDate"
                  placeholder="Sélectionnez une date"
                  locale="fr-FR"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  @input="formatDateToFrench" />
               </validation-provider>

            </b-form-group>
          </b-col>


          <b-col class="d-flex " md="6">
            <b-form-group>
              <label for="InputHelp">Administration</label>
              <b-form-radio-group v-model="user.role" :options="options" class="demo-inline-spacing"
                name="Administration"   @change="logRoleChange"
/>
            </b-form-group>
          </b-col>

          
          <b-col class="d-flex " md="4">
            <b-button variant="primary" @click="openAddModal">
              <span  v-ripple.400="'rgba(255, 255, 255, 0.15)'" class="text-nowrap">Ajouter une signature</span>
            </b-button>
          </b-col>
          <!-- <b-col  md="2">
            <b-form-group>
              <b-img
                ref="refPreviewEl"
                :src="signatureImageUrl"
                height="110"
                width="170"
                class="rounded mr-2 mb-1 mb-md-0"
              />
            </b-form-group>
            
          </b-col> -->
        </b-row>
      </validation-observer>
    </b-card>
    <b-modal v-model="isModalActive" title='Ajouter une signature' ok-only ok-title="Valider" centered>
      <signature-upload-view :signature="signatureSend" @inputImageRenderer="handleImageSelection" />
    </b-modal>
  </div>
</template>

<script>
import {BCard, BCol, BFormDatepicker, BFormGroup, BFormInput, BFormRadioGroup, BRow, BModal, BButton} from 'bootstrap-vue'
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import SignatureUploadView from '../objectif/SignatureUploadView.vue'
import Ripple from 'vue-ripple-directive';


export default {
  directives: {
    Ripple,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    BCard,
    //BFormCheckbox,
    BFormInput,
    BFormGroup,
    BFormRadioGroup,
    BRow,
    // flatPickr,
    BCol,
    SignatureUploadView,
    BFormDatepicker,
    BModal,BButton
  },
  props: {
    existingUser: {
      type: Object,
      default: () => null,
    },
  },
  data() {
   

    return {
      maxDate: new Date().toISOString().split("T")[0], // Limite maximale à aujourd'hui

      
      isModalActive: false,
      signatureImageUrl: null,
      signatureSend: null,
      selectedDate: null,
      user: {
        lastName: '',
        firstName: '',
        mail: '',
        telephone: '',
        role: null,
        fonctionDate: null,
        signature: null,
        matricule:'',
        civilite:''
      },
      // options: [
      //  // { text: 'Super Administrateur', value: '' },
      //   { text: 'Administrateur', value: 'Admin' },
      //   // { text: 'Manager', value: 'Hierarchy' },
      //   { text: 'Utilisateur', value: 'User' },
      // ],
      options: [
        { text: 'Super Administrateur', value: 'AdminSuper' },
        { text: 'Administrateur', value: 'Admin' },
        // { text: 'Manager', value: 'Hierarchy' },
        { text: 'Utilisateur', value: 'User' },
      ],
    }
  },
  watch: {
    existingUser: {
      handler(newValue) {
        if (newValue) {
          // this.user = {
          //   lastName: '',
          //   firstName: '',
          //   mail: '',
          //   telephone: '',
          //   role: null,
          //   fonctionDate: null,
          //   signature: null,
          //   matricule: null,
          //   civilite:'',
          //   ...newValue, // Valeurs initiales si présentes
          // };
          this.user = { ...this.user, ...newValue };
          if (newValue.fonctionDate) {
            // Supposons que fonctionDate est au format DD-MM-YYYY
            const [day, month, year] = newValue.fonctionDate.split('-');
            if (day && month && year && !isNaN(day) && !isNaN(month) && !isNaN(year)) {
              // Correction : Créer la date en LOCAL (pas UTC) pour éviter le décalage
              const dateObject = new Date(Number(year), Number(month) - 1, Number(day));
              if (!isNaN(dateObject.getTime())) {
                // Utiliser les méthodes LOCALES pour extraire YYYY-MM-DD (évite toISOString() qui convertit en UTC)
                const yyyy = dateObject.getFullYear();
                const mm = String(dateObject.getMonth() + 1).padStart(2, '0');
                const dd = String(dateObject.getDate()).padStart(2, '0');
                this.selectedDate = `${yyyy}-${mm}-${dd}`;
              } else {
                this.selectedDate = null;
              }
            } else {
              this.selectedDate = null;
            }

          } else {
            this.selectedDate = null;
          }
        }
      },
      immediate: true,
    },
  },

  methods: {
    logRoleChange() {
      this.emitUserInfoUpdate(); // Pour propager la mise à jour
    },
    formatDateToFrench(date) {
      if (date) {
        // Correction : Parser en LOCAL et utiliser les méthodes LOCALES pour formater DD-MM-YYYY
        const dateObject = new Date(date);
        const day = String(dateObject.getDate()).padStart(2, '0');
        const month = String(dateObject.getMonth() + 1).padStart(2, '0');
        const year = dateObject.getFullYear();

        this.user.fonctionDate = `${day}-${month}-${year}`;
        this.emitUserInfoUpdate();
      } else {
        this.user.fonctionDate = null;
        this.selectedDate = null;
      }
    },

    emitUserInfoUpdate() {

     
      this.$emit('update-info', { ...this.user });
    },

    validateForm() {
      return this.$refs.observer.validate();
    },
    handleImageSelection(bytes) {
      const base64Signature = btoa(String.fromCharCode(...new Uint8Array(bytes)))
      this.user.signature = base64Signature
      this.signatureSend = base64Signature

    },
    toggleRole() {
  
      this.emitUserInfoUpdate();
    },
    openAddModal() {
      this.isModalActive = true
    },

    updateForm(data) {
      if (data && data.fonctionDate) {
        const dateParts = data.fonctionDate.split('-');
        if (dateParts.length === 3) {
          const [day, month, year] = dateParts;
          if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
            // Correction : Créer la date en LOCAL et utiliser les méthodes LOCALES
            const dateObject = new Date(Number(year), Number(month) - 1, Number(day));
            if (!isNaN(dateObject.getTime())) {
              const yyyy = dateObject.getFullYear();
              const mm = String(dateObject.getMonth() + 1).padStart(2, '0');
              const dd = String(dateObject.getDate()).padStart(2, '0');
              const formattedDate = `${yyyy}-${mm}-${dd}`;
              this.user = { ...this.user, ...data };
              this.selectedDate = formattedDate;
            }
          }
        }
      } else {
        this.user = { ...this.user, ...data };
        this.selectedDate = null;
      }
    },
   
    reset() {
      this.user = {
        lastName: '',
        firstName: '',
        mail: '',
        telephone: '',
        role: '',
        fonctionDate: null,
        signature: null,
        matricule: null,
        civilite:'',
      };
      this.selectedDate=null;
    },

  }

}
</script>

<style lang="scss" scoped>
.mb-1 {
  margin-bottom: 1rem;
}

@import '@core/scss/vue/libs/vue-flatpicker.scss';

@import '@core/scss/vue/libs/vue-select.scss';
</style>
